/* eslint-disable lines-between-class-members,dot-notation,import/no-cycle */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { City } from "../City/City";
import { Company } from "../Companies";
import { Customer } from "../Customers";
import { OrderPayment } from "./OrderPayment";
import { OrderProduct } from "./OrderProduct";
import { allStatuses, allStatusesTypes, deliveryMethods, deliveryMethodsTypes, deliveryRegions, deliveryRegionsTypes, orderDelivery, orderDeliveryTypes, paymentMethods, paymentMethodsTypes, pointMethods, pointMethodsTypes, sources, sourcesTypes } from "./statuses";
/**
 * Order class
 */

export class Order extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getPrice = () => {
      return Number(this.model.price);
    };

    this.getOnlinePrice = () => {
      return Number(this.model.onlinePrice);
    };

    this.getDeliveryPrice = () => {
      return Number(this.model.deliveryPrice);
    };

    this.getPaymentMethod = (asLabel = false) => {
      return asLabel ? Order.paymentMethods[this.model.paymentMethod || 'unknown'] || Order.paymentMethods['unknown'] : this.model.paymentMethod;
    };

    this.getPointMethod = (asLabel = false) => {
      return asLabel ? Order.pointMethods[this.model.pointMethod || 'unknown'] || Order.pointMethods['unknown'] : this.model.pointMethod;
    };

    this.getDeliveryRegion = (asLabel = false) => {
      return asLabel ? Order.deliveryRegions[this.model.deliveryRegion || 'unknown'] || Order.deliveryRegions['unknown'] : this.model.deliveryRegion;
    };

    this.getSource = (asLabel = false) => {
      return asLabel ? Order.sources[this.model.source || 'unknown'] || Order.sources['unknown'] : this.model.source;
    };

    this.getDeliveryMethod = (asLabel = false) => {
      return asLabel ? Order.deliveryMethods[this.model.deliveryMethod || 'unknown'] || Order.deliveryMethods['unknown'] : this.model.deliveryMethod;
    };

    this.getDeliveryType = (asLabel = false) => {
      return asLabel ? Order.orderDeliveryTypes[this.model.deliveryType || 'unknown'] || Order.orderDeliveryTypes['unknown'] : this.model.deliveryType;
    };

    this.getDeliveryFrom = () => this.model.deliveryFrom;

    this.getRawDeliveryAddress = () => this.model.deliveryAddress;

    this.getDeliveryAddress = () => {
      const {
        apartment,
        block,
        house,
        street
      } = this.model.deliveryAddress;

      const _ = (prefix, value) => value && `${prefix} ${value}; ` || '';

      return `${_('ул.', street)} ${_('д.', house)} ${_('блок', block)} ${_('кв.', apartment)}`.trim();
    };

    this.getDeliveryTo = () => {
      return this.model.deliveryTo;
    };

    this.getStatus = (asLabel = false) => {
      return asLabel ? Order.statuses[this.model.status || 'unknown'] || Order.statuses['unknown'] : this.model.status;
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getCustomerId = () => {
      return this.model.customerId;
    };

    this.getCityId = () => {
      return this.model.cityId;
    };

    this.getCustomer = customer => {
      return this.getRelation('customer', Customer, customer);
    };

    this.getCity = city => {
      return this.getRelation('city', City, city);
    };

    this.getCompany = company => {
      return this.getRelation('company', Company, company);
    };

    this.getProducts = products => {
      return this.getRelation('products', OrderProduct, products, true);
    };

    this.getPayment = payment => {
      return this.getRelation('payment', OrderPayment, payment);
    };
  }

  /**
   * Create order
   *
   * @param {object} object
   *
   * @return {Order}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list orders
   *
   * @param {object} objects
   *
   * @return {Array.<Order>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map orders
   *
   * @param {Array.<object>} objects
   * @param {function(Order): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get order id
   *
   * @return {number}
   */


}
Order.statuses = allStatuses;
Order.statusesTypes = allStatusesTypes;
Order.paymentMethods = paymentMethods;
Order.paymentMethodsTypes = paymentMethodsTypes;
Order.pointMethods = pointMethods;
Order.pointMethodsTypes = pointMethodsTypes;
Order.deliveryRegions = deliveryRegions;
Order.deliveryRegionsTypes = deliveryRegionsTypes;
Order.deliveryMethods = deliveryMethods;
Order.deliveryMethodsTypes = deliveryMethodsTypes;
Order.orderDelivery = orderDelivery;
Order.orderDeliveryTypes = orderDeliveryTypes;
Order.sources = sources;
Order.sourcesTypes = sourcesTypes;